module.exports = __webpack_public_path__ + "img/icon_mentale_gesundheit.c38b085a.svg";